import { createContext } from 'use-context-selector';

import type { StickyCampaignHeaderContextProps } from './StickyCampaignHeaderContext.types';

import { notImplemented } from 'utils/notImplemented';

export const stickyCampaignHeaderContextInitialProps: StickyCampaignHeaderContextProps = {
  refs: {
    setHeader: notImplemented,
    setScroll: notImplemented,
  },
};

export const StickyCampaignHeaderContext = createContext(stickyCampaignHeaderContextInitialProps);
